import { AdmDataGrid } from "@components/common/data-grid/adm-data-grid";
import { AdmProject } from "@custom-types/base-types";
import { useSearchProjectsTableColumns } from "@pages/home/search/search-tables/search-projects-tables/use-search-projects-table-columns";
import { useAppNavigation } from "@router/use-app-navigation";
import { MainPageEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";

interface Props {
  /** List of projects that match the search text */
  projects: AdmProject[];
}

/** Shows a list of projects that match the search text */
export function SearchProjectsTable({ projects }: Props): React.JSX.Element {
  const columns = useSearchProjectsTableColumns();
  const { navigateToProfilePage } = useAppNavigation();
  const { trackEvent } = useTrackEvent();

  return (
    <AdmDataGrid
      entities={projects}
      uniqueIdKey="id"
      tableType="search-projects-table"
      columns={columns}
      // Data is coming from somewhere else with error handling. So no need to show error in here.
      errorMessage=""
      shouldShowErrorMessage={false}
      onRowClick={(projectId) => {
        trackEvent({
          name: MainPageEvents.openItem,
          props: {
            target: "PROJECT",
            location: "search result",
          },
        });
        navigateToProfilePage({
          subjectType: "PROJECT",
          subjectId: projectId,
        });
      }}
      defaultSortModel={[{ field: "name", sort: "asc" }]}
    />
  );
}
